import { RotateCcw } from "lucide-react";

export function Field({ label, children, testId }) {
  return (
    <label className="flex flex-col gap-1.5 min-w-0" data-testid={testId}>
      <span className="pp-label">{label}</span>
      {children}
    </label>
  );
}

export function FilterBar({ masters, filters, setFilters, showHour = true }) {
  const { plants, sections, lines, shifts } = masters;
  const set = (k, v) => setFilters((f) => {
    const n = { ...f, [k]: v };
    if (k === "plant_id") { n.section_id = ""; n.line_id = ""; }
    if (k === "section_id") n.line_id = "";
    if (k === "shift_id") n.hour = "";
    return n;
  });
  const secs = sections.filter((s) => !filters.plant_id || s.plant_id === filters.plant_id);
  const lns = lines.filter((l) => (!filters.plant_id || l.plant_id === filters.plant_id) && (!filters.section_id || l.section_id === filters.section_id));
  const shift = shifts.find((s) => s.id === filters.shift_id);
  const hours = shift ? shift.hours : shifts.flatMap((s) => s.hours);

  return (
    <div className="pp-card p-4 grid grid-cols-2 md:grid-cols-3 xl:grid-cols-7 gap-3 items-end" data-testid="filter-bar">
      <Field label="Date"><input type="date" className="pp-input" value={filters.reporting_date} onChange={(e) => set("reporting_date", e.target.value)} data-testid="filter-date" /></Field>
      <Field label="Plant">
        <select className="pp-select" value={filters.plant_id} onChange={(e) => set("plant_id", e.target.value)} data-testid="filter-plant">
          <option value="">All plants</option>
          {plants.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
        </select>
      </Field>
      <Field label="Section">
        <select className="pp-select" value={filters.section_id} onChange={(e) => set("section_id", e.target.value)} data-testid="filter-section">
          <option value="">All sections</option>
          {secs.map((s) => <option key={s.id} value={s.id}>{`${s.name} (${s.code})`}</option>)}
        </select>
      </Field>
      <Field label="Line">
        <select className="pp-select" value={filters.line_id} onChange={(e) => set("line_id", e.target.value)} data-testid="filter-line">
          <option value="">All lines</option>
          {lns.map((l) => <option key={l.id} value={l.id}>{`${l.code} · ${l.name}`}</option>)}
        </select>
      </Field>
      <Field label="Shift">
        <select className="pp-select" value={filters.shift_id} onChange={(e) => set("shift_id", e.target.value)} data-testid="filter-shift">
          <option value="">All shifts</option>
          {shifts.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select>
      </Field>
      {showHour && (
        <Field label="Hour">
          <select className="pp-select" value={filters.hour} onChange={(e) => set("hour", e.target.value)} data-testid="filter-hour">
            <option value="">All hours</option>
            {hours.map((h, i) => <option key={`${h.hour}-${i}`} value={h.hour}>{h.label}</option>)}
          </select>
        </Field>
      )}
      <button className="pp-btn-ghost" data-testid="filter-reset" onClick={() => setFilters((f) => ({ reporting_date: f.reporting_date, plant_id: "", section_id: "", line_id: "", shift_id: "", hour: "" }))}><RotateCcw size={14} /> Reset</button>
    </div>
  );
}
